import React, { useState } from "react";
import {
    Home,
    Users,
    Shield,
    ChevronDown,
    ChevronRight,
    LogOut,
    CheckSquare,
    Settings,
    MapPin,
    Zap,
    DollarSign,
    Database,
    User,
    BarChart3,
    Bell,
} from "lucide-react";
import {
    Box,
    Drawer,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Collapse,
    Typography,
    Button,
} from "@mui/material";
import { NavLink, useLocation } from "react-router-dom";
import { sidenavStyle } from "../../styles/layout";
import { useTheme } from "@mui/material/styles";
import LogoutModel from "./logoutModel";
import Logo from "@shared/Assets/Image/miniLogo.png";
import { ApiConfig } from "@shared/Config/config"

const navItems = [
    { id: "dashboard", label: "Dashboard", icon: Home, screen: "dashboard", path: "dashboard" },
    { id: "agents", label: "Agents", icon: Users, screen: "agents", path: "agents" },
    { id: "teams", label: "Teams", icon: Shield, screen: "teams", path: "teams" },
    { id: "tasks", label: "Orders", icon: CheckSquare, screen: "tasks", path: "tasks" },
    { id: "geo-fence", label: "Geo-Fence", icon: MapPin, screen: "geo-fence", path: "geo-fence" },
    // { id: "profile", label: "Profile", icon: User, screen: "profile", path: "profile" },
    // { id: "customize", label: "Customize", icon: Settings, screen: "customize", path: "customize" }, 
    {
        id: "auto-allocation",
        label: "Auto Allocation",
        icon: Zap,
        screen: "auto-allocation",
        path: "auto-allocation",
    },

    // {
    //     id: "analytics-map",
    //     label: "Bird's Eye Map",
    //     icon: MapPin,
    //     screen: "analytics-map",
    //     path: "birds-eye-view",
    // },

    // { id: "configure", label: "Configure", icon: Database, screen: "configure", path: "system-configuration" },
    // {
    //     id: "analytics",
    //     label: "Analytics",
    //     icon: BarChart3,
    //     children: [
    //         {
    //             id: "analytics-overview",
    //             label: "Overview",
    //             icon: BarChart3,
    //             screen: "analytics-overview",
    //             path: "analytics-overview",
    //         },
    //         {
    //             id: "analytics-map",
    //             label: "Bird's Eye Map",
    //             icon: MapPin,
    //             screen: "analytics-map",
    //             path: "birds-eye-view",
    //         },
    //         {
    //             id: "analytics-reports",
    //             label: "Reports",
    //             icon: BarChart3,
    //             screen: "analytics-reports",
    //             path: "analytics-reports",
    //         },
    //     ],
    // },
    {
        id: "notifications",
        label: "Notifications",
        icon: Bell,
        screen: "notifications",
        path: "notifications",
    },
];

export default function Sidebar({ onLogout }) {
    const theme = useTheme();
    const classes = sidenavStyle(theme);
    const [expandedItems, setExpandedItems] = useState(new Set(["analytics"]));
    const [openDialog, setOpenDialog] = useState(false);
    const location = useLocation();

    const toggleExpanded = (itemId) => {
        setExpandedItems((prev) => {
            const newSet = new Set(prev);
            if (newSet.has(itemId)) {
                newSet.delete(itemId);
            } else {
                newSet.add(itemId);
            }
            return newSet;
        });
    };

    const renderNavItem = (item, depth = 0) => {
        const isExpanded = expandedItems.has(item.id);
        const hasChildren = item.children && item.children.length > 0;
        return (
            <React.Fragment key={item.id}>
                <>
                    <NavLink to={item.path}>
                        <ListItemButton
                            onClick={() => {
                                if (hasChildren) {
                                    toggleExpanded(item.id);
                                }
                            }}
                            sx={location.pathname.includes(item.path) ? classes.active : classes.inactive}
                        >
                            {/* {item.path}  {pl: depth > 0 ? 2 + depth * 2 : 2}*/}

                            <ListItemIcon sx={{ minWidth: 32 }}>
                                <item.icon
                                    size={18}
                                    color={location.pathname.includes(item.path) ? theme.palette.primary.main : theme.palette.text.primary}
                                />
                            </ListItemIcon>
                            <ListItemText
                                primary={item.label}
                                sx={{ '& .MuiListItemText-primary': { fontWeight: 600, fontSize: 14 } }}
                            />
                            {hasChildren &&
                                (isExpanded ? <ChevronDown size={18} /> : <ChevronRight size={18} />)}
                        </ListItemButton>
                    </NavLink>
                </>

                {hasChildren && (
                    <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            {item.children.map((child) => renderNavItem(child, depth + 1))}
                        </List>
                    </Collapse>
                )}
            </React.Fragment>
        );
    };

    return (
        <Drawer
            variant="permanent"
            sx={classes.drawerDiv}
        >
            {/* Logo */}
            <Box sx={classes.sidenavHeader}>
                <img src={Logo} alt="Logo" style={classes.logo} />
                <Box>
                    <Typography variant="subtitle1" fontWeight="600">
                        Dispatcher
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                        Sub-Admin Panel
                    </Typography>
                </Box>
            </Box>

            <Box sx={classes.sidenavBody}>
                <List>
                    {navItems.map((item) => renderNavItem(item))}
                </List>

                <Box sx={classes.versionDiv}>
                    <Typography variant="body2" align="center">
                        {ApiConfig?.ver_admin}
                    </Typography>
                </Box>

                <Box sx={{ px: 2 }}>
                    <Button
                        variant="outlined"
                        fullWidth
                        startIcon={<LogOut size={18} />}
                        onClick={() => setOpenDialog(true)}
                    >
                        Sign Out
                    </Button>
                </Box>
            </Box>

            <LogoutModel
                openDialog={openDialog}
                setOpenDialog={setOpenDialog}
                onLogout={onLogout}
            />

        </Drawer>
    );
}
